import React from "react";
import Review from "./Review";

const Reviews = ({ product }) => {
  const reviews = product?.reviews;

  if (!reviews || reviews.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-6 text-gray-700 border border-gray-300 border-dashed bg-gradient-to-r from-purple-100 via-pink-100 to-yellow-100">
       
        <p className="text-lg font-semibold">No Reviews Yet!</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {reviews.map((review, index) => (
        <Review key={index} review={review} />
      ))}
    </div>
  );
};

export default Reviews;

